import { displayCellValue } from '../../../utils/column-values.util';
import { useMediaQuery } from 'react-responsive';

export const SUPPLIERS_COLUMNS = [
    {
        Header: "Supplier Name",
        accessor: "supplierName",
        style: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 2
        }
    },
    {
        Header: "Supplier Phone",
        accessor: "supplierPhone",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return null;
            }

            return displayCellValue(value);
        }
    },
    {
        Header: "Supplier TIN No",
        accessor: "supplierTinNumber",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `Tin: ${displayCellValue(value)}`;
            }


            return displayCellValue(value);
        }
    },
    {
        Header: "Supplier Code",
        accessor: "supplierCode",
    },
]